import { ModalOpenButton } from "@msys/ui";
import { Button } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { CreateQuoteFromQuoteModal } from "../modals/CreateQuoteFromQuoteModal.js";

interface Props {
  projectId: string;
  sourceQuoteId: string;
  pathToDocList: string;
}

export function CreateQuoteFromQuoteButton({
  projectId,
  sourceQuoteId,
  pathToDocList,
}: Props) {
  const { t } = useTranslate("Quote");

  return (
    <ModalOpenButton
      Modal={CreateQuoteFromQuoteModal}
      modalProps={{ projectId, sourceQuoteId, pathToDocList }}
    >
      <Button color="primary" variant="contained">
        {t("Create client quote")}
      </Button>
    </ModalOpenButton>
  );
}
